import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function RegistrationCancelled() {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to right, #003973, #E5E5BE)',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: 'white',
            p: 4,
            borderRadius: 2,
            textAlign: 'center',
            boxShadow: 3,
          }}
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <ErrorOutlineIcon
              sx={{ fontSize: 80, color: 'warning.main', mb: 2 }}
            />
          </motion.div>
          <Typography variant="h4" gutterBottom>
            Registration Incomplete
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            Your payment was not completed. Your account has been created but needs to be activated with payment.
          </Typography>
          <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/login')}
            >
              Try Again
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate('/')}
            >
              Go Home
            </Button>
          </Box>
        </Box>
      </Container>
    </motion.div>
  );
}

export default RegistrationCancelled; 